export const unsupportedEditorBrowserMessage =
    "This workflow requires desktop Chrome, Edge, or Brave. Safari, Firefox, and mobile browsers aren't supported yet.";

export const isLibrettoMacApp = () => {
    try {
        return typeof window !== "undefined" && window.__LIBRETTO_PLATFORM__ === "macos";
    } catch {
        return false;
    }
};

export const isSupportedChromeEdgeOrBrave = () => {
    if (typeof navigator === "undefined") return true;

    const userAgent = navigator.userAgent || "";
    const isIOS = /iPhone|iPad|iPod/i.test(userAgent);
    if (isIOS) return false;

    try {
        const brands = navigator.userAgentData?.brands?.map((brand) => brand.brand) || [];
        if (brands.includes("Google Chrome") || brands.includes("Microsoft Edge") || brands.includes("Brave")) {
            return true;
        }
        // Chromium automation commonly exposes only the generic "Chromium"
        // brand. Do not reject an otherwise Chrome-compatible browser before
        // checking its user agent below.
    } catch {
    }

    const isBrave =
        /Brave\//.test(userAgent) ||
        (typeof navigator.brave === "object" && typeof navigator.brave?.isBrave === "function");
    const isEdge = /Edg\//.test(userAgent) || /EdgA\//.test(userAgent);
    const isChrome =
        /Chrome\//.test(userAgent) &&
        !/Edg\//.test(userAgent) &&
        !/EdgA\//.test(userAgent) &&
        !/OPR\//.test(userAgent) &&
        !/Opera\//.test(userAgent) &&
        !/Brave\//.test(userAgent) &&
        !/Vivaldi\//.test(userAgent);

    return isBrave || isEdge || isChrome;
};
